// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"7d8fd093","772":"46461aa1"}[chunkId] + ".chunk.js";
};